import { StyledBroadsiderTrait } from './BroadsiderTrait.styled';

const BroadsiderTrait = ({ trait }) => {
  const topLabel = `${trait ? trait.name : ''}:`;// ${trait ? trait.percentage : '0.0'}%`;
  const bottomLabel = `${trait ? trait.value: ''}`;
  return (
    <StyledBroadsiderTrait $placeholder={!trait}>
      <div className='trait-top'>{topLabel}</div>
      <div className='trait-bottom'>{bottomLabel}</div>
    </StyledBroadsiderTrait>
  );
};

export default BroadsiderTrait;
